// Navigation menu palettes for client color review.
// Every class string is a complete literal so Tailwind can detect it —
// never build these names dynamically.

export type NavThemeName = 'purple' | 'sage' | 'charcoal'

export interface NavTheme {
  name: NavThemeName
  /** Where Home + logo link to, so previews don't reset to the default option */
  homeHref: string
  /** Desktop band background + bottom border (gold top rule is applied separately) */
  bar: string
  /** Hover fill for top-level items (desktop + mobile) */
  itemHover: string
  /** Fill for an open dropdown trigger (desktop + mobile) */
  itemOpen: string
  /** Focus ring offset color matching the band background */
  ringOffset: string
  /** Mobile Menu toggle button */
  toggle: string
  /** Expanded mobile navigation group background + side/bottom border */
  mobileGroup: string
  /** Mobile inline submenu link text */
  mobileSubText: string
}

// Approved site-wide default (September update): sage green with white lettering.
const sageDefault: NavTheme = {
  name: 'sage',
  homeHref: '/',
  bar: 'bg-[#5E7463] border-b-[#425648]',
  itemHover: 'hover:bg-[#4B6051]',
  itemOpen: 'bg-[#4B6051]',
  ringOffset: 'focus-visible:ring-offset-[#5E7463]',
  toggle: 'border-[#425648] bg-[#5E7463] hover:bg-[#4B6051]',
  mobileGroup: 'bg-[#5E7463] border-[#425648]',
  mobileSubText: 'text-white',
}

// Reference-only review preview (keeps Home on the preview URL).
const sage: NavTheme = {
  name: 'sage',
  homeHref: '/color-options/sage',
  bar: 'bg-[#5E7463] border-b-[#425648]',
  itemHover: 'hover:bg-[#4B6051]',
  itemOpen: 'bg-[#4B6051]',
  ringOffset: 'focus-visible:ring-offset-[#5E7463]',
  toggle: 'border-[#425648] bg-[#5E7463] hover:bg-[#4B6051]',
  mobileGroup: 'bg-[#5E7463] border-[#425648]',
  mobileSubText: 'text-white',
}

const charcoal: NavTheme = {
  name: 'charcoal',
  homeHref: '/color-options/charcoal',
  bar: 'bg-[#454B52] border-b-[#30363C]',
  itemHover: 'hover:bg-[#343A40]',
  itemOpen: 'bg-[#343A40]',
  ringOffset: 'focus-visible:ring-offset-[#454B52]',
  toggle: 'border-[#30363C] bg-[#454B52] hover:bg-[#343A40]',
  mobileGroup: 'bg-[#454B52] border-[#30363C]',
  mobileSubText: 'text-white',
}

/** Picks the menu palette for the current path; approved sage is the default everywhere else. */
export function getNavTheme(pathname: string): NavTheme {
  const path = pathname.replace(/\/+$/, '').toLowerCase()
  if (path === '/color-options/sage') return sage
  if (path === '/color-options/charcoal') return charcoal
  return sageDefault
}
